<template>
  <div class="container">
    <div class="row h-50">
        <div class="form-group col my-4">
            <h2 class="message">To invite a Guest Driver, enter your name and 10 digit mobile number.</h2>
            <p>
                <label class="message" for="senderFirstName">Sender First Name</label>
                <input class="form-control"
                       id="senderFirstName"
                       v-model="senderFirstName"
                       type="text"
                       name="senderFirstName">
                <label class="message" for="senderLastName">Sender Last Name</label>
                <input class="form-control"
                       id="senderLastName"
                       v-model="senderLastName"
                       type="text"
                       name="senderLastName">
                <label class="message" for="phone">Mobile Number</label>
                <input class="form-control"
                        id="phone"
                        v-model="phone"
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        type="tel"
                        name="phone">
                <label class="message" for="email">Email Address (Optional)</label>
                <input class="form-control"
                       id="email"
                       v-model="email"
                       pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                       type="email"
                       name="email">
            </p>
            <div class="py-3" style="text-align: center">
                <button class="ty-button" v-on:click="sendLink">Send Invite</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "InviteDriver",
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      senderFirstName:null,
      senderLastName:null,
      phone:null,
      email:null,
      errors: []
    };
  },

  mounted() {
    this.geolocate();
  },

  methods: {
    sendLink: function () {
        const inviteAPI = 'https://oa-poi-helper.herokuapp.com/invite-driver'
        //const inviteAPI = 'http://localhost:3000/invite-driver'

        this.axios.post(inviteAPI ,{
          headers: {
            'Content-Type':'application/json'
          },
          data:{
            senderFirstName:this.senderFirstName,
            senderLastName:this.senderLastName,
            toNumber:'+1'+this.phone,
            toEmail:this.email
          }
        }).then((response) => {
          // eslint-disable-next-line no-console
          console.log("message: ", response)
          alert(`SMS/Email sent to ${this.phone}`)
        }).catch((e) => {
          // eslint-disable-next-line no-console
          console.log("error: ", e)
          alert(`SMS/Email was not sent`)
        })
      }
  }
};
</script>
<style scoped>
a:link {
        color:#FFFFFF;
}
.btn {
    color:#FFFFFF;
}
.ty-button{
    background: #4281ff;
    /*border-radius: 22px;*/
    width:343px;
    height:64px;
    /*font-family: Helvetica;*/
    font-family: ToyotaType-Semibold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.73px;
    text-align: center;
}
</style>
